export const SET_APP_LANGUAGE = "SET_APP_LANGUAGE";

export const setAppLanguage = (lang) => ({
    type: SET_APP_LANGUAGE,
    payload: lang,
});
